import React from "react";

const OrganicPedicureXp = () => {
  return (
    <div className="salonXpContainer">
      <h5>The Organic Pedicure Experience</h5>
      <p>
        Our <a href="https://scentlifestyle.com/organic-pedicure">Organic Pedicure at SCENT</a> is a comprehensive
        treatment that combines traditional pedicure techniques with the
        benefits of organic products. Here’s what you can expect during your
        session:
      </p>
      <ul>
        <li>
          <h6>Refreshing Foot Soak:x</h6> The pedicure begins with a warm foot
          soak infused with organic essential oils and natural salts. This step
          helps to soften the skin, relax the muscles, and prepare your feet for
          the treatment.
        </li>
        <li>
          <h6>Nail Trimming and Shaping:</h6> Our technicians will carefully
          trim and shape your nails to your desired length and style. Proper
          nail care is essential to prevent ingrown nails and maintain healthy
          nail growth.
        </li>
        <li>
          <h6>Cuticle Care:</h6> The cuticles are gently pushed back and trimmed
          to ensure a neat and clean appearance. We use nourishing cuticle oils
          to keep the cuticles hydrated and healthy.
        </li>
        <li>
          <h6>Exfoliation:</h6> Dead skin cells are removed through gentle
          exfoliation using a scrub that contains natural exfoliants. This step
          helps to reveal smoother, softer skin and prevents the build-up of
          calluses.
        </li>
        <li>
          <h6> Callus Removal:</h6> For areas with hardened skin or calluses,
          our technicians use specialized tools to gently buff away the rough
          patches. This leaves your feet feeling smooth and refreshed.
        </li>
        <li>
          <h6>Foot Massage:</h6>One of the highlights of our{" "}
          <a href="https://scentlifestyle.com/organic-pedicure">Organic Pedicure</a> is the relaxing foot massage. Using a
          blend of organic oils and lotions, our technicians will work to
          relieve tension and improve circulation in your feet and lower legs.
          This not only feels amazing but also promotes overall foot health.
        </li>
        <li>
          <h6>Moisturizing:</h6> After the massage, a rich and hydrating lotion
          is applied to your feet and legs. This helps to lock in moisture and
          keep your skin soft and supple.
        </li>
        <li>
          <h6>Polish Application:</h6> The final step is the application of nail
          polish. Choose from our wide range of colors, including classic shades
          and trendy hues. Our technicians will apply a base coat, two layers of
          your chosen color, and a top coat to ensure a long-lasting and
          flawless finish.
        </li>
      </ul>
    </div>
  );
};

export default OrganicPedicureXp;
